/**
 * DOM writes that happen only when the value changes.
 *
 * The HUD is updated every frame, and it wrote about ten texts and attributes
 * each time whether they had changed or not. The clock shows tenths, so at
 * 60 fps most of those writes changed nothing, yet each one costs the browser
 * style, layout and paint: letting the HUD write one frame in six cut that from
 * 5.4 to 2.6 ms a frame on a slowed phone (performance review, 2026-10-26,
 * problem 4). Reading a value back does not force layout; writing it does.
 *
 * Each returns whether it wrote. The types are the least each one needs, so a
 * test can hand it a plain object.
 */

export function setText(node: { textContent: string | null }, text: string): boolean {
  if (node.textContent === text) return false;
  node.textContent = text;
  return true;
}

export function setData(
  node: { readonly dataset: Record<string, string | undefined> },
  key: string,
  value: string,
): boolean {
  if (node.dataset[key] === value) return false;
  node.dataset[key] = value;
  return true;
}

export function setHidden(node: { hidden: boolean }, hidden: boolean): boolean {
  if (node.hidden === hidden) return false;
  node.hidden = hidden;
  return true;
}

/** Shown as its stylesheet says, or `display: none`. */
export function setShown(node: { readonly style: { display: string } }, shown: boolean): boolean {
  const display = shown ? '' : 'none';
  if (node.style.display === display) return false;
  node.style.display = display;
  return true;
}
